<template>
  <div>
    <v-snackbar
      v-model="snackbar.showMsg"
      top
      :vertical="true"
      :color="snackbar.color"
    >
      {{ snackbar.msgContent }}
      <template v-slot:action="{ attrs }">
        <v-btn
          dark
          color="white"
          text
          v-bind="attrs"
          @click="snackbar.showMsg = false"
        >
          Close
        </v-btn>
      </template>
    </v-snackbar>

    <v-data-table
      v-model="selected"
      :headers="headers"
      :items="getUnverifiedMAR"
      item-key="_id"
      show-select
      class="elevation-1"
      :loading="$store.state.mar.loading"
    >
      <template v-slot:top>
        <v-toolbar flat>
          <v-toolbar-title>
            <span class="text-subtitle-1"
              >Medication Verification for the last 3 days</span
            ></v-toolbar-title
          >
          <v-divider class="mx-4" inset vertical></v-divider>
          <v-spacer></v-spacer>
          <template>
            <v-btn v-if="!userRole" color="primary" dark class="mb-2" @click="verify">
              Verify Selected
            </v-btn>
          </template>
        </v-toolbar>
      </template>
    </v-data-table>
  </div>
</template>

<script>
/*eslint-disable*/
import { mapGetters, mapActions, mapMutations } from "vuex";
import { setUserTz, setUserSignatureTz, tz } from "../../../../utils/timezone";
export default {
  props: {
    clientID: {
      type: String,
      default: "",
    },
    staff: {
      type: String,
      default: "",
    },
    userSignatureTz: {
      type: Object,
    },
    userRole: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      selected: [],
      headers: [
        {
          text: "Date",
          align: "start",
          sortable: false,
          value: "Date",
        },
        { text: "Scheduled Admin Time", value: "AdminTime" },
        { text: "Medication", value: "Medication" },
        { text: "Notes", value: "Notes" },
        { text: "Verified By", value: "VerifiedBy" },
      ],
      verifiedBy: "",
      snackbar: {
        showMsg: false,
        msgContent: "",
        color: "green accent-4",
      },
    };
  },

  created() {
    this.getClientUnverifiedMAR(this.clientID);
  },

  computed: {
    ...mapGetters("mar", ["getUnverifiedMAR"]),
  },

  methods: {
    ...mapActions({
      getClientUnverifiedMAR: "mar/getClientUnverifiedMAR",
      verifyMAR: "mar/verifyMAR",
    }),

    ...mapMutations({
      setSnackbar: "mar/SET_SNACKBAR",
    }),

    async verify() {
      if(this.selected.length === 0) return alert('Nothing Selected')
      this.verifiedBy = this.staff + " - " + setUserSignatureTz(this.userSignatureTz);
      const selectedIds = this.selected.map((item) => item._id);
      try {
        const response = await this.verifyMAR({
          data: { selectedIds, verifiedBy: this.verifiedBy },
          id: this.clientID,
        });

        if (response.success) {
          this.snackbar.showMsg = true;
          this.snackbar.msgContent = "Succesfully Verified Med/s";
          this.snackbar.color = "green accent-4";
        }
      } catch (error) {
        console.log(error);
      }
    },
  },
};
</script>
